// The charge is not persisted server-side: it comes in the creation response and
// reaches the waiting screen through sessionStorage, surviving a refresh.
export const PIX_CHARGE_STORAGE_PREFIX = 'curseduca:pix-charge:';

export const PIX_CONSENT_STORAGE_PREFIX = 'curseduca:pix-consent:';

export type PixCharge = {
	qrCode: string | null;
	qrCodeImage: string | null;
	paymentUrl: string | null;
	expiresIn: string | number | null;
};
